import React from 'react'

interface IDeCollectionPopup {
    onClose: () => void;
    onDelete: () => void
}

const DeleteCollectionPopup = (props: IDeCollectionPopup) => {
    return (
        <div className="lcs-modal-overlay">
            <div className="lcs-modal">
                <button className="lcs-modal__close" onClick={props.onClose}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                        <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                </button>

                <div className="lcs-modal__icon">
                    <img src="/assets/images/trash-red-icon.svg" alt="" width="48" height="48" />
                </div>
                <h2 className="lcs-modal__title">Delete Collection</h2>
                <p className="lcs-modal__desc">Are you sure you want to delete collection?</p>

                <div className="lcs-modal__buttons">
                    <button className="lcs-modal__btn lcs-modal__btn--cancel" onClick={props.onClose}>
                        No, Keep Collection
                    </button>
                    <button className="lcs-modal__btn lcs-modal__btn--delete" onClick={props.onDelete}>
                        Yes, Delete Collection
                    </button>
                </div>
            </div>
        </div>
    )
}

export default DeleteCollectionPopup